Whether to include all events, or only events that have failed to be delivered.
